<template>
  <div id="app">
    <el-container style="height:100%;">
      <el-header v-if="false">
        <router-view name="header"></router-view>
      </el-header>
      <el-main style="height:100%;">
        <el-container style="height:100%;">
          <el-aside v-if="headerIsShow">
            <router-view name="aside"></router-view>
          </el-aside>
          <el-aside :class="$route.name">
            <router-view name="left"></router-view>
          </el-aside>
          <el-main style="height:100%">
            <router-view :key="$route.fullpath"></router-view>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import {getUrlParam} from "@/assets/js/common.js"
export default {
  name: "app",
  data() {
    return {
      headerIsShow:true
    };
  },
  watch:{
    $route(newVal,oldVal){
      this.hideVisualHeader()
    }
  },
  computed: {},
  created() {
    if(process.env.domain){
      var hostName=location.hostname
      var arr = hostName.split('.')
      var domain = arr[arr.length-2]+'.'+arr[arr.length-1]
      var noDomain = ['com.cn','net.cn','org.cn','gov.cn','edu.cn']
      if(noDomain.indexOf(domain)>-1){
          domain = arr[arr.length-3]+'.'+domain
      }
      document.domain = domain;
      // document.domain = process.env.domain;
    }
    this.getTenantInfo();
    this.hideVisualHeader();
    this.updateGroupId();
  },
  methods: {
    hideVisualHeader(){
      this.headerIsShow = !!this.$route.path.indexOf('/visual') && !!this.$route.path.indexOf('/adminManage')
      this.isPageNotFound = this.$route.path.includes('pageNotFound')
    },

    // 存集团id
    updateGroupId() {
      this.$store.commit('updateGroupId', getUrlParam('groupId') || window.localStorage.getItem('groupId'));
    },
    //获取用户信息
    getTenantInfo() {
      this.$store.dispatch('getTenantInfo')
    },
  }
};
</script>

<style lang = "less" scoped>
#app {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// App.vue?77a2c06e